import React from "react";
import PropTypes from "prop-types";
import { TwoRow } from "core/layouts";

function HomeLayout({
  className,
  bottomSection,
  topSection,
  topSectionStyle,
  bottomSectionStyle,
  style,
}) {
  return (
    <TwoRow
      style={style}
      topSection={topSection}
      topSectionStyle={topSectionStyle}
      bottomSection={bottomSection}
      bottomSectionStyle={{ ...bottomSectionStyle, flex: 1 }}
    />
  );
}

HomeLayout.defaultProps = {
  className: "",
  style: {},
};

HomeLayout.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

export default HomeLayout;
